import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Card,
  Button,
  Stack,
  Tooltip,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import {
  useLocation
} from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm, Controller } from "react-hook-form";
import { makeStyles } from '@mui/styles';
import SelectDropdown from "../common/FormSelectDropdown";
import TextInput from "../common/TextInput";
import { useLoader } from "../../../pages/LoaderContext";
import { successToast, errorToast } from "../../utils/toast";
import { ToastContainer } from 'react-toastify';
import UnSavedModal from "../common/UnSavedModal"
import { useAppContext } from '../../../hooks/context/AppContext';
import { useProjectApiClient } from "../../Services/api/projectService"
import ValidationModal from "../common/ValidationModal"
import AutoSaveModal from "../common/AutoSaveModal"
import useIdle from '../../../hooks/useIdle';

import { useApiClient } from "../../Services/api/sheqService"
import { useNavigate, useParams } from "react-router-dom";
import { projectVersion } from "config/navConfig";
import FileUpload from "../common/FileUpload";
import UploadList from "v2/components/common/UploadsList";
import circleArrowIcon from "../../../assets/images/circle-arrow-icon.svg"
import uploadIcon from "../../../assets/images/upload-icon.svg";


const useStyles = makeStyles({
  themeButton: {
    backgroundColor: '#2a3fbf !important',
    padding: "8px 30px",
    fontWeight: "700",
    '&:hover': { backgroundColor: '#2a3fbf !important' },
  },
  cancelButton: {
    backgroundColor: "#d9d9d9 !important",
    color: "#626262 !important",
    padding: "8px 30px",
    fontWeight: "700",
    '&:hover': { backgroundColor: '#d9d9d9 !important', color: '#626262 !important' },
  }
});


const schema = yup.object().shape({
  hygieneRisk: yup.string(),
  transitTrail: yup.string(),
  seacRisk: yup.string(),
  plasticInclusion: yup.string(),
  ghgImpact: yup.string(),
  qualityApproved: yup.string(),
  technicalAssesmentRisk: yup.string(),
  sheqRisk: yup.string(),
  comment: yup.string().nullable(),
});

interface AuditEntry {
  fieldName: string;
  oldValue: string;
  newValue: string;
}

const SEO: React.FC = () => {
  const location = useLocation();
  const {
    getProjectDetails,
    getRequiredField,
    publishProjectOnSave,
    uploadProjectFile
  } = useProjectApiClient();
  const { projectId, projectKey } = useParams<{ projectKey: string; projectId: string }>();
  const {
    getRisk,
    getTransitTrails,
    getPlastciInclusion,
    getHygiene,
    getQualityApproved,
    getGhgImpact,
    getSeacRisks,
    getTechnicalAssesmentRisks,
    createSheq,
    updateSheq,
    getSheq
  } = useApiClient();
  const { appData, updateAppData, userData } = useAppContext();
  const navigate = useNavigate();
  const classes = useStyles();
  const [hygieneRisks, setHygieneRisks] = useState([])
  const [transitTrails, setTransitTrails] = useState([])
  const [seacRisks, setSeacRisks] = useState([])
  const [plasticInclusions, setPlasticInclusions] = useState([])
  const [ghgImpacts, setGhgImpacts] = useState([])
  const [qualitiesApproved, setQualitiesApproved] = useState([])
  const [technicalAssesmentRisks, setTechnicalAssesmentRisks] = useState([])
  const [sheqRisks, setSheqRisks] = useState([])
  const { setLoading } = useLoader();
  const [isExisting, setIsExisting] = useState(false)
  const [isDisabled, setIsDisabled] = useState(true);
  const [validationErrors, setValidationErrors] = useState({})
  const [isValidationError, setIsValidationError] = useState(false)
  const [projectDetails, setProjectDetails] = useState({
    issaved: false
  })
  const [isDraftDisabled, setIsDraftDisabled] = useState(false);
  const [autoSaveModal, setAutoSaveModal] = React.useState<boolean>(false);
  const isIdle = useIdle(60000 * 10)
  const hasAutoSaved = useRef(false);
  const [isUpload, setIsUpload] = React.useState<boolean>(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);


  const [formData, setFormData] = useState({
    hygieneRisk: '',
    transitTrail: '',
    seacRisk: '',
    plasticInclusion: '',
    ghgImpact: '',
    qualityApproved: '',
    technicalAssesmentRisk: '',
    sheqRisk: '',
    comment: ''
  })

  const [initialformData, setInitialformData] = useState({
    hygieneRisk: '',
    transitTrail: '',
    seacRisk: '',
    plasticInclusion: '',
    ghgImpact: '',
    qualityApproved: '',
    technicalAssesmentRisk: '',
    sheqRisk: '',
    comment: ''
  })

  const {
    handleSubmit,
    control,
    clearErrors,
    reset,
    formState: { errors },
    setValue
  } = useForm({
    defaultValues: {},
    // @ts-ignore
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (userData) {
      setIsDisabled(!userData.permissions.CanEdit)
    }
  }, [userData]);


  useEffect(() => {
    // @ts-ignore
    reset(formData);
  }, [formData]);

  useEffect(() => {

    const fetchOptions = async () => {
      await Promise.all([
        fetchHygieneRisk(),
        fetchQualitiesApproved(),
        fetchGhgImpact(),
        fetchTransitTrails(),
        fetchRisk(),
        fetchPlasticInclusion(),
        fetchTechnicalAssesmentRisks(),
        fetchSeacRisks(),
        fetchsProjectDetails()
      ]);
    };
    fetchOptions();
    if (projectKey) {
      window.setTimeout(() => {
        fetchSheqDetails(projectKey);
      }, 500);
    }
  }, [projectKey]);

  useEffect(() => {
    if (isIdle && !autoSaveModal) {
      let check = JSON.stringify(formData) === JSON.stringify(initialformData);
      if (!check && !hasAutoSaved.current) {
        setAutoSaveModal(true);
      }
    }
  }, [isIdle]);

  useEffect(() => {
    let check = JSON.stringify(formData) === JSON.stringify(initialformData);
    if (!check) {
      updateAppData({ isFormChanged: true, showUnSavedModal: false });
    } else {
      updateAppData({ isFormChanged: false, showUnSavedModal: false });
    }

  }, [formData]);


  const fetchsProjectDetails = async () => {
    try {
      const data = await getProjectDetails(projectId);
      if (data) {
        setProjectDetails({ issaved: data.issaved });
        setIsDraftDisabled(data.issaved);
      }

    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };


  const fetchSheqDetails = async (key: string) => {
    try {
      setLoading(true)
      const response = await getSheq(key);
      setLoading(false)
      if (response) {
        const data = response.data;
        if (data.Sustainability_Id) {
          setIsExisting(true)
        }

        let projectData = {
          hygieneRisk: JSON.stringify(data.Hygiene_Risk),
          transitTrail: JSON.stringify(data.TransitTrials_Key),
          seacRisk: JSON.stringify(data.Seac_Risk),
          plasticInclusion: JSON.stringify(data.Plastic_Inclusion_Key),
          ghgImpact: JSON.stringify(data.Ghg_Impact),
          qualityApproved: JSON.stringify(data.Su_Cm_Quality_Approved),
          technicalAssesmentRisk: JSON.stringify(data.Technical_Assessment_Risk),
          sheqRisk: JSON.stringify(data.Risk_Key),
          comment: data.Comment
        }
        setFormData(projectData)
        setInitialformData(projectData)
        window.setTimeout(() => {
          Object.keys(projectData).forEach((key) => {
            setValue(
              key as any,
              projectData[key as keyof typeof projectData]
            );
          });
        }, 1000);
      }
    } catch (error) {

      console.error(" Failed to fetch projects:", error);
    } finally {

    }
  };



  const fetchRequiredField = async () => {
    try {
      const data = await getRequiredField(projectKey);
      return data
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {

    }
  };

  let groupByModule = (errors: any) => {
    return errors.reduce((grouped: any, error: any) => {
      const { ModuleName, Message } = error;
      if (!grouped[ModuleName]) {
        grouped[ModuleName] = [];
      }
      grouped[ModuleName].push(Message);
      return grouped;
    }, {});
  }

  let closeValidationModal = () => {
    setIsValidationError(false)
    setValidationErrors({})
  }
  let pubLishProjectData = async () => {
    let res = await publishProjectOnSave(projectKey)
    if (res && res.issaved !== undefined) {
      setProjectDetails({ issaved: res.issaved });
      setIsDraftDisabled(res.issaved)
    }
  }


  const getCompleteAuditTrail = (initialData: Record<string, any>, updatedData: Record<string, any>): AuditEntry[] => {
    const audit: AuditEntry[] = [];
    const keys = Object.keys(initialData);
    for (const key of keys) {
      if (key === 'project_id') continue;

      const oldValue = initialData[key];
      const newValue = updatedData[key];

      audit.push({
        fieldName: key,
        oldValue: String(oldValue),
        newValue: String(newValue)
      });
    }

    return audit;
  }

  const onSubmit = async (data: any, type: any, url: string) => {
    let resField = await fetchRequiredField()
    if ((type === true) && (resField?.data && resField?.data.length)) {
      const groupedErrors = groupByModule(resField?.data);
      setValidationErrors(groupedErrors)
      setIsValidationError(true)
      return
    }
    let payload = {
      "Risk_Key": data.sheqRisk,
      "Hygiene_Risk": data.hygieneRisk,
      "TransitTrials_Key": data.transitTrail,
      "Seac_Risk": data.seacRisk,
      "Plastic_Inclusion_Key": data.plasticInclusion,
      "Ghg_Impact": data.ghgImpact,
      "Su_Cm_Quality_Approved": data.qualityApproved,
      "Technical_Assessment_Risk": data.technicalAssesmentRisk,
      "Comment": data.comment,
    }

    let initialPayload = {
      "Risk_Key": initialformData.sheqRisk,
      "Hygiene_Risk": initialformData.hygieneRisk,
      "TransitTrials_Key": initialformData.transitTrail,
      "Seac_Risk": initialformData.seacRisk,
      "Plastic_Inclusion_Key": initialformData.plasticInclusion,
      "Ghg_Impact": initialformData.ghgImpact,
      "Su_Cm_Quality_Approved": initialformData.qualityApproved,
      "Technical_Assessment_Risk": initialformData.technicalAssesmentRisk,
      "Comment": initialformData.comment,
    }

    const completeAuditTrail = getCompleteAuditTrail(initialPayload, payload);
    {/* @ts-ignore */ }
    payload.audit = completeAuditTrail;

    if (!isExisting) {
      {/* @ts-ignore */ }
      let res = await createSheq(payload, projectKey)
      if (type === true) { await pubLishProjectData(); setProjectDetails({ issaved: true }); setIsDraftDisabled(type) };
      updateAppData({ isFormChanged: false, showUnSavedModal: false, url: appData.url });
      if (res) {
        setIsExisting(true)
        {/* @ts-ignore */ }
        successToast(res.message)
        setTimeout(() => {
          if (type === true) { navigate(url ? url : `${projectVersion}/project/sheq-sustainability/${projectId}/${projectKey}`); }
          else { navigate(url ? url : `${projectVersion}/project/logistics/${projectId}/${projectKey}`); }
        }, 3000);
      }
    } else {
      {/* @ts-ignore */ }
      let res = await updateSheq(payload, projectKey)
      if (projectKey) {
        fetchSheqDetails(projectKey);
      }
      if (type === true) { await pubLishProjectData(); setProjectDetails({ issaved: true }); setIsDraftDisabled(type); };
      updateAppData({ isFormChanged: false, showUnSavedModal: false, url: appData.url });
      if (res) {
        {/* @ts-ignore */ }
        successToast(res.message)
        setTimeout(() => {
          if (type === true) { navigate(url ? url : `${projectVersion}/project/sheq-sustainability/${projectId}/${projectKey}`); }
          else { navigate(url ? url : `${projectVersion}/project/logistics/${projectId}/${projectKey}`); }
        }, 3000);
      }
    }

  }

  const handleFormSubmit = (type: any, url: string) => {
    return handleSubmit((data) => onSubmit(data, type, url));
  };


  const fetchHygieneRisk = async () => {
    try {
      const data = await getHygiene();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez
      }));
      // @ts-ignore
      setHygieneRisks(output)
      // @ts-ignore
      // setQualitiesApproved(output)
      // // @ts-ignore
      // setGhgImpacts(output)
    } catch (error) {
      console.error(" Failed to fetch Hygiene Risk:", error);
    } finally {
    }
  };
  const fetchQualitiesApproved = async () => {
    try {
      const data = await getQualityApproved();
      // console.log("dater0->,n tena data", data)
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez
      }));
      // @ts-ignore
      setQualitiesApproved(output)
    } catch (error) {
      console.error(" Failed to fetch Quality Approved:", error);
    }
  };
  const fetchGhgImpact = async () => {
    try {
      const data = await getGhgImpact();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez
      }));
      // @ts-ignore
      setGhgImpacts(output)
    } catch (error) {
      console.error(" Failed to fetch GHG Impact:", error);
    }
  };

  const fetchTransitTrails = async () => {
    try {
      const data = await getTransitTrails();
      // console.log("dater0->,n tena data", data)
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez
      }));
      // @ts-ignore
      setTransitTrails(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };

  const fetchPlasticInclusion = async () => {
    try {
      const data = await getPlastciInclusion();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez
      }));
      // @ts-ignore
      setPlasticInclusions(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };

  const fetchTechnicalAssesmentRisks = async () => {
    try {
      const data = await getTechnicalAssesmentRisks();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez
      }));
      // @ts-ignore 
      setTechnicalAssesmentRisks(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };
  const fetchSeacRisks = async () => {
    try {
      const data = await getSeacRisks();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez
      }));
      // @ts-ignore   
      setSeacRisks(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };

  const fetchRisk = async () => {
    try {
      const data = await getRisk();
      //console.log("dater0->,n riskk data", data)
      let output = data.map((item: any) => ({
        key: item.Risk_key,
        value: item.Risk_name
      }));
      // @ts-ignore  
      setSheqRisks(output)
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };


  let handleFilterChange = async (name: any, value: any) => {
    setFormData({
      ...formData,
      [name]: value
    })
    hasAutoSaved.current = false;
  }

  let handleFormChange = (name: any, value: any) => {
    setFormData({
      ...formData,
      [name]: value
    })
    hasAutoSaved.current = false;
  }

  let closeUnSavedModal = () => {
    updateAppData({ isFormChanged: true, showUnSavedModal: false, url: '' });
  }
  let saveUnSavedModal = () => {
    handleFormSubmit(true, appData.url)()
  }
  let draftSavedModal = () => {
    updateAppData({ isFormChanged: false, showUnSavedModal: false, url: appData.url });
    handleFormSubmit(false, appData.url)()
  }
  const discardModal = () => {
    // reset form, redirect, or just close modal
    updateAppData({ isFormChanged: false, showUnSavedModal: false, url: appData.url });
    navigate(appData.url);
  };
  let handleCancel = () => {
    if (!appData.isFormChanged) {
      navigate(`${projectVersion}/projects-grid`)
    } else {
      updateAppData({ isFormChanged: true, showUnSavedModal: true });
    }

  }

  const autoSave = async () => {
    setAutoSaveModal(false);
    try {
      let resField = await fetchRequiredField()
      if (resField?.data && resField?.data.length) {
        await handleFormSubmit(false, '')();
        hasAutoSaved.current = true;
      } else {
        await handleFormSubmit(true, '')();
        hasAutoSaved.current = true;
      }
    } catch (error) {
      console.error("Auto-save failed:", error);
    }
  };

  let closeAutoSave = () => {
    setAutoSaveModal(false)
  }
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const uploadFlag = searchParams.get("isUpload") === "true";
    if (uploadFlag) {
      setIsUpload(true);
      searchParams.delete("isUpload");
    }
  }, [location.search, location.pathname]);

  let handlebackUpload = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete("isUpload");

    navigate(
      {
        pathname: location.pathname,
        search: searchParams.toString()
          ? `?${searchParams.toString()}`
          : "", // no query string if empty
      },
      { replace: true }
    );

    setIsUpload(false);
  };

  const handleProjectFileChange = async (file: any) => {
    const allowedTypes = [
      'application/pdf',
      'application/msword',                       // .doc
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
      'application/vnd.ms-excel',                 // .xls
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',       // .xlsx
      'application/vnd.ms-powerpoint',            // .ppt
      'application/vnd.openxmlformats-officedocument.presentationml.presentation' // .pptx
    ];
    if (!allowedTypes.includes(file.type)) {
      errorToast('Only PDF, PPT, XLS or DOC formats are allowed.');
      return;
    }
    setLoading(true)
    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB in bytes
    if (file.size > MAX_FILE_SIZE) {
      errorToast('File size must be less than 5 MB');
      return;
    }
    try {
      const formdata = new FormData();
      formdata.append("file", file, file.name);
      let data = await uploadProjectFile(projectKey, 8, formdata);
      //  successToast(data.message)
      setLoading(false)
      setRefreshTrigger(prev => prev + 1);

    } catch (error) {
      console.error('Error uploading file:', error);
      errorToast('Failed to upload file. Please try again.');
    }
  };

  let handleClickUpload = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("isUpload", "true");

    navigate(
      {
        pathname: location.pathname,
        search: `?${searchParams.toString()}`,
      },
      { replace: true }
    );
    setIsUpload(true);
  };


  return (
    <>
      <ToastContainer />

      <div className="create-project-content">
        <Card className="" sx={{ padding: "30px", borderRadius: "20px", pt: 3 }}>
          {/* Buttons - Save, Draft, Cancel */}
          <Box>
            <div className="button-top-form" style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Stack
                direction="row"
                spacing={2}
                sx={{ justifyContent: "start", pb: 4 }}
              >
                {
                  isUpload ?
                    <Button onClick={() => handlebackUpload()} sx={{ border: '0px', fontSize: '14px', color: '#B5B5B5', p: 0, textTransform: 'capitalize' }}><img src={circleArrowIcon} className="wtsback--img" /></Button>
                    :
                    null
                }

              </Stack>
              {
                !isUpload ?

                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{ justifyContent: "end", pb: 4 }}
                  >
                    {
                      localStorage.user_info && JSON.parse(localStorage.user_info).Role !== '' ?
                        JSON.parse(localStorage.user_info).Role !== 'ProjectViewer' ?
                          <Tooltip title="Upload Documents" arrow>
                            <Button
                              onClick={() => handleClickUpload()}
                              sx={{ p: 0, minWidth: 'auto', width: '38px', height: '38px', border: '1px solid #000', borderRadius: '50%' }}
                            >
                              <img src={uploadIcon} className="icon-wt-uplad" />
                            </Button>
                          </Tooltip>
                          :
                          <>
                          </>
                        :
                        null
                    }
                    <Button disabled={isDisabled} onClick={handleFormSubmit(true, '')} variant="contained"
                      sx={{ borderRadius: '30px', px: 4, py: 1, textTransform: 'capitalize', color: 'white !important', backgroundColor: `${isDisabled ? '#d9d9d9 !important' : '#2a3fbf !important'}` }} className={classes.themeButton}>Submit</Button>

                    <Button
                      disabled={isDisabled || projectDetails.issaved}
                      onClick={handleFormSubmit(false, '')}
                      variant="contained"
                      sx={{
                        borderRadius: '30px',
                        px: 4,
                        py: 1,
                        textTransform: 'capitalize',
                        color: 'white !important',
                        backgroundColor: '#2a3fbf !important',
                        '&.Mui-disabled': {
                          backgroundColor: '#d9d9d9 !important',
                          color: '#5f6368 !important'
                        }
                      }}
                      className={classes.themeButton}
                    >
                      Draft & Continue
                    </Button>
                    <Button disabled={isDisabled} onClick={handleCancel} variant="contained" sx={{ borderRadius: '30px', px: 4, py: 1, textTransform: 'capitalize' }} className={classes.cancelButton}>Cancel</Button>

                  </Stack>
                  :
                  <>
                    <div className="file-upload-button">
                      <FileUpload isProjectUpload={true} isDisabled={false} onFileChange={handleProjectFileChange}
                        name="uploadPic" label="Browse" control={control} errors={errors} />
                    </div>
                  </>
              }


            </div>
          </Box>

          {
            isUpload ?
              <>
                {/* @ts-ignore */}
                <UploadList refreshTrigger={refreshTrigger} setLoading={setLoading} moduleId={8}></UploadList>
              </>
              :
              <form noValidate>
                <Grid container spacing={3}>
                  <Grid size={12}>
                    {/* <h5 className="txt-mandatory-title">*Fields are mandatory</h5> */}
                  </Grid>
                  <Grid size={4}>
                    <label className="txt-label-input">Hygiene Risk</label>
                    <div className="project_drpdnw">
                      <Controller
                        name="hygieneRisk"
                        control={control}
                        render={({ field }) => (
                          <SelectDropdown
                            isDisabled={isDisabled}
                            filterKey=""
                            label=""
                            value={field.value}
                            onChange={(val) => {
                              field.onChange(val);
                              handleFilterChange("hygieneRisk", val);
                              clearErrors("hygieneRisk");
                            }}
                            options={hygieneRisks}
                            isError={!!errors.hygieneRisk}
                          />
                        )}
                      />
                    </div>
                    {errors.hygieneRisk && <p className="error-message">{errors.hygieneRisk.message}</p>}
                  </Grid>

                  <Grid size={4}>
                    <label className="txt-label-input">Transit Trails</label>
                    <div className="project_drpdnw">
                      <Controller
                        name="transitTrail"
                        control={control}
                        render={({ field }) => (
                          <SelectDropdown
                            isDisabled={isDisabled}
                            filterKey=""
                            label=""
                            value={field.value}
                            onChange={(val) => {
                              field.onChange(val);
                              handleFilterChange("transitTrail", val);
                              clearErrors("transitTrail");
                            }}
                            options={transitTrails}
                            isError={!!errors.transitTrail}
                          />
                        )}
                      />
                    </div>
                    {errors.transitTrail && <p className="error-message">{errors.transitTrail.message}</p>}
                  </Grid>

                  <Grid size={4}>
                    <label className="txt-label-input">SEAC Risk</label>
                    <div className="project_drpdnw">
                      <Controller
                        name="seacRisk"
                        control={control}
                        render={({ field }) => (
                          <SelectDropdown
                            isDisabled={isDisabled}
                            filterKey=""
                            label=""
                            value={field.value}
                            onChange={(val) => {
                              field.onChange(val);
                              handleFilterChange("seacRisk", val);
                              clearErrors("seacRisk");
                            }}
                            options={seacRisks}
                            isError={!!errors.seacRisk}
                          />
                        )}
                      />
                    </div>
                  </Grid>



                  <Grid size={4}>
                    <label className="txt-label-input">Plastic Inclusion</label>
                    <div className="project_drpdnw">
                      <Controller
                        name="plasticInclusion"
                        control={control}
                        render={({ field }) => (
                          <SelectDropdown
                            isDisabled={isDisabled}
                            filterKey=""
                            label=""
                            value={field.value}
                            onChange={(val) => {
                              field.onChange(val);
                              handleFilterChange("plasticInclusion", val);
                              clearErrors("plasticInclusion");
                            }}
                            options={plasticInclusions}
                            isError={!!errors.plasticInclusion}
                          />
                        )}
                      />
                    </div>
                  </Grid>


                  <Grid size={4}>
                    <label className="txt-label-input">GHC Impact</label>
                    <div className="project_drpdnw">
                      <Controller
                        name="ghgImpact"
                        control={control}
                        render={({ field }) => (
                          <SelectDropdown
                            isDisabled={isDisabled}
                            filterKey=""
                            label=""
                            value={field.value}
                            onChange={(val) => {
                              field.onChange(val);
                              handleFilterChange("ghgImpact", val);
                              clearErrors("ghgImpact");
                            }}
                            options={ghgImpacts}
                            isError={!!errors.ghgImpact}
                          />
                        )}
                      />
                    </div>
                  </Grid>

                  <Grid size={4}>
                    <label className="txt-label-input">SU/ CM Quality Approved</label>
                    <div className="project_drpdnw">
                      <Controller
                        name="qualityApproved"
                        control={control}
                        render={({ field }) => (
                          <SelectDropdown
                            isDisabled={isDisabled}
                            filterKey=""
                            label=""
                            value={field.value}
                            onChange={(val) => {
                              field.onChange(val);
                              handleFilterChange("qualityApproved", val);
                              clearErrors("qualityApproved");
                            }}
                            options={qualitiesApproved}
                            isError={!!errors.qualityApproved}
                          />
                        )}
                      />
                    </div>
                  </Grid>

                  <Grid size={4}>
                    <label className="txt-label-input">Technical Risk Assessment</label>
                    <div className="project_drpdnw">
                      <Controller
                        name="technicalAssesmentRisk"
                        control={control}
                        render={({ field }) => (
                          <SelectDropdown
                            isDisabled={isDisabled}
                            filterKey=""
                            label=""
                            value={field.value}
                            onChange={(val) => {
                              field.onChange(val);
                              handleFilterChange("technicalAssesmentRisk", val);
                              clearErrors("technicalAssesmentRisk");
                            }}
                            options={technicalAssesmentRisks}
                            isError={!!errors.technicalAssesmentRisk}
                          />
                        )}
                      />
                    </div>
                  </Grid>
                </Grid>
                <Grid container spacing={3} mt={2}>
                  <Grid size={8}>
                    <label className="txt-label-input">Comment</label>
                    <TextInput isDisabled={isDisabled} className="comment-input" isComment={true} onChange={(e) => handleFormChange(e.target.name, e.target.value)} name="comment" label="" control={control} errors={errors} multiline />
                  </Grid>
                  <Grid size={4}>
                    <label className="txt-label-input">SHEQ Risk</label>
                    <div className="project_drpdnw">
                      <Controller
                        name="sheqRisk"
                        control={control}
                        render={({ field }) => (
                          <SelectDropdown
                            isDisabled={isDisabled}
                            filterKey=""
                            label=""
                            value={field.value}
                            onChange={(val) => {
                              field.onChange(val);
                              handleFilterChange("sheqRisk", val);
                              clearErrors("sheqRisk");
                            }}
                            options={sheqRisks}
                            isError={!!errors.sheqRisk}
                          />
                        )}
                      />
                    </div>
                  </Grid>

                </Grid>

              </form>
          }
        </Card>
      </div>
      {/* @ts-ignore */}
      <UnSavedModal close={closeUnSavedModal} saveUnSavedModal={saveUnSavedModal} draftSavedModal={draftSavedModal} discardModal={discardModal} isDraftDisabled={isDraftDisabled} />
      <ValidationModal validationErrors={validationErrors} open={isValidationError} closeValidationModal={closeValidationModal} />
      <AutoSaveModal open={autoSaveModal} closeAutoSave={closeAutoSave} autoSave={autoSave} ></AutoSaveModal>
    </>


  );
};

export default SEO;